import { Box, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>404 — PDFGlyph</title>
      </Helmet>
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          p: 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontWeight: 800,
            fontSize: { xs: 64, md: 96 },
            background: "linear-gradient(135deg, #1d4ed8, #a78bfa)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          404
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          Page not found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </Typography>
        <Button
          component={RouterLink}
          to="/"
          sx={{
            borderRadius: 24,
            background: "linear-gradient(135deg, #1d4ed8, #a78bfa)",
            color: "white",
            px: 3,
            py: 1,
            fontWeight: 600,
            "&:hover": { opacity: 0.9 },
          }}
        >
          Go home
        </Button>
      </Box>
    </>
  );
}
